export const evergabeFooterData = [
  {
    type: "FooterHeroColumn",
    title: "B_I eVergabe",
    link: "/evergabe",
    youtube: "https://www.youtube.com/channel/UCojRk_tvvwegr0hZRYIhX-w",
    paragraph:
      "Unsere Software für die Vergabe öffentlicher Aufträge aller Art.",
  },
  {
    type: "FooterSpacerMobile",
  },
  {
    type: "FooterColumn",
    title: "Produkt",
    link: "/evergabe",
    paragraph: "",
    column_items: [
      {
        type: "FooterLink",
        link: "/evergabe/produkt",
        label: "Aufträge einfach vergeben",
      },
      {
        type: "FooterLink",
        link: "/evergabe/preise",
        label: "Preise vergleichen",
      },
    ],
  },
  {
    type: "FooterSpacerMobile",
  },
  {
    type: "FooterColumn",
    title: "Vergabe-Wissen",
    link: "/vergabe-wissen",
    paragraph: "",
    column_items: [
      {
        type: "FooterLink",
        link: "/vergabe-wissen/lexikon",
        label: "Fachbegriffe der Vergabe",
      },
      {
        type: "FooterLink",
        link: "/vergabe-wissen/news",
        label: "Aktuelle Nachrichten",
      },
      {
        type: "FooterLink",
        link: "/evergabe/wie-gelingt-die-erste-elektronische-vergabe",
        label: "Einführung in die eVergabe",
      },
    ],
  },
  {
    type: "FooterSpacerMobile",
  },
  {
    type: "FooterColumn",
    title: "Support",
    link: "/evergabe/support",
    paragraph: "",
    column_items: [
      {
        type: "FooterLink",
        link: "/evergabe/support",
        label: "Zum Helpcenter",
      },
      {
        type: "FooterLink",
        link: "/evergabe/support",
        label: "Kontakt aufnehmen",
      },
      {
        type: "FooterLink",
        link: "/evergabe/support/formblaetter",
        label: "Formblätter herunterladen",
      },
      {
        type: "FooterLink",
        link: "/evergabe/support/vorlagen-bekanntmachungen",
        label: "Vorlagen für Bekanntmachungen",
      },
    ],
  },
]
